import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {saveStateToHistory, loadStateFromHistory, removeStateFromHistory, clearStateHistory} from '../stateUtils';

export const saveStateToHistoryAction = createAsyncThunk('stateHistory/saveStateToHistory', (key, thunkApi) => {
  let currentState = {...thunkApi.getState()};
  delete currentState.iContentRepo;
  saveStateToHistory(key, currentState);
});

export const saveStateToHistoryActionSaleJet = createAsyncThunk('stateHistory/saveStateToHistory', (data, thunkApi) => {
  let currentState = {...thunkApi.getState()};
  delete currentState.iContentRepo;
  currentState.saleJetBlock = {...currentState.saleJetBlock, page: data.page};
  saveStateToHistory(data.url, currentState);
});

export const removeStateFromHistoryAction = createAsyncThunk('stateHistory/removeStateFromHistory', (key) => {
  removeStateFromHistory(key);
});

export const loadStateFromHistoryAction = createAsyncThunk('stateHistory/loadStateFromHistory', (key) => {
  return loadStateFromHistory(key);
});

export const clearStateHistoryAction = createAsyncThunk('stateHistory/clearStateHistory', (key) => {
  clearStateHistory(key);
});

const stateHistorySlice = createSlice({
  name: 'stateHistory',
  initialState: {
    isStateReset: false,
    returnUrl: '',
  },
  reducers: {
    resetIsStateReset: (state, action) => {
      state.isStateReset = false;
    },
    setReturnUrl: (state, action) => {
      state.returnUrl = action.payload;
    },
  },
  extraReducers: {
    ['RESET_APP']: (state, action) => {
      state.isStateReset = true;
    },
  },
});

export const RESTORE_FROM_HISTORY = 'RESTORE_FROM_HISTORY';

/** Replace a single slice from a history snapshot (handled by rootReducer). */
export const restoreFromHistory = (sliceKey, data) => ({
  type: RESTORE_FROM_HISTORY,
  payload: {sliceKey, data},
});

export const {resetIsStateReset, setReturnUrl} = stateHistorySlice.actions;
export default stateHistorySlice.reducer;
